export default __webpack_public_path__ + "49aed3ea6515382188f66b02b1e1bea2.png";